import { render } from "./BreadcrumbSelect.vue?vue&type=template&id=40ca8804&scoped=true"
import script from "./BreadcrumbSelect.vue?vue&type=script&lang=js"
export * from "./BreadcrumbSelect.vue?vue&type=script&lang=js"

import "./BreadcrumbSelect.vue?vue&type=style&index=0&id=40ca8804&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ca8804"]])

export default __exports__